import React from "react";

const About = () => {
  
  return (
    <div id="about-container">
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />
    <h2>about us</h2>
    </div>

  );
};

export default About;
